import { isFeature } from 'Cloud/Application/FeaturesEs6';

// https://jira.vk.team/browse/CLOUDWEB-19314 - Убрать из тултипа в Облаке ссылку на чистилку
export const hideCleanerInAttaches = isFeature('hide-cleaner-in-attaches');
